/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_HeadingInputs */



/**
* | output |
* | --- |
* | "Plugin Management" |
*
* @param {Team_Manager_Plugins_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_heading = /** @type {((inputs?: Team_Manager_Plugins_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestion des plug-ins")
	if (locale === "de") return /** @type {LocalizedString} */ ("Plugin-Verwaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestione dei plugin")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление плагинами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestión de complementos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插件管理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プラグイン管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लगइन प्रबंधन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciamento de plugins")
	return /** @type {LocalizedString} */ ("Plugin Management")
});